(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wl-product-slideout"] && !Shopify.designMode) return;
  try {
    $(document).ready(function(){
    let open = false;
    $('.atc-close').on('click', function() {
        closeATCDrawer();
    });

    $('.atc-trigger').on('click', function() {
        let handle = $(this).data('handle');
        loadProduct(handle);
        setTimeout(function () {
            $('.atc-drawer--wrapper').fadeIn();
            $('.atc-drawer').animate({right: '0px'}, "fast");
            $('.atc-close').addClass('active');
            $('.atc-image-gallery').slick({
                infinite: false,
                autoplay: false,
                arrows: false,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1
            });
        
        }, 500);
    });
  });

  function closeATCDrawer() {
    $('.atc-drawer').animate({right: '-440px'}, "fast");
    $('.atc-close').removeClass('active');
    $('.atc-drawer--wrapper').fadeOut();
  }

  function loadSlickTrack() {
    $('.atc-image-gallery').slick('setPosition');
  }

/* Drawer Product/Add to Cart functionality */
function formatMoney(cents, currencyCode) {
  currencyCode = currencyCode || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  return new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode }).format(cents / 100);
}

// Builds a checkbox+label per option value, grouped by option index.
// Checkboxes behave like a single-select radio group (JS enforces exactly
// one checked checkbox per group) but keep the requested checkbox markup.
function buildVariantPicker(product) {
  if (!product.options || product.options.length === 0 || (product.options.length === 1 && product.options[0] === 'Title')) {
    return ''; // single-variant product, no picker needed
  }

  const currentVariant = product.variants.find((v) => v.available) || product.variants[0];

  return product.options
  .map((option, index) => {
    const optionName = typeof option === 'string' ? option : option.name;

    const values = [...new Set(product.variants.map((v) => v.options[index]))];
    const currentValue = currentVariant.options[index];

    const checkboxesHtml = values
      .map((val) => {
        const inputId = `option-${index}-${val}`.replace(/\s+/g, '-');
        const isChecked = val === currentValue;
        return `
          <input
            type="checkbox"
            class="variant-option-checkbox opt-btn visually-hidden focus-label js-option"
            id="${inputId}"
            data-option-index="${index}"
            value="${val}"
            ${isChecked ? 'checked' : ''}
          >
          <label for="${inputId}" class="variant-option-label opt-label opt-label--btn btn relative text-center">${val}</label>
        `;
      })
      .join('');

    return `
      <div class="option-row" data-option-index="${index}">
        <span class="label">${optionName}</span>
        <div class="variant-option-group option-selector__btns" data-option-index="${index}">
          ${checkboxesHtml}
        </div>
      </div>
    `;
  })
  .join('');
}

function findMatchingVariant(product, selectedOptions) {
  return product.variants.find((variant) =>
    variant.options.every((val, i) => val === selectedOptions[i])
  );
}

function buildTruncatedDescription(description) {
  return `
    <div class="description-wrapper" data-expanded="false">
      <div class="description-content description-content--clamped rte cf">${description}</div>
      <button type="button" class="description-toggle" aria-expanded="false">Read more</button>
    </div>
  `;
}
 
function renderProductDrawer(product) {
  const currentVariant = product.variants.find((v) => v.available) || product.variants[0];

  const imagesHtml = (product.images || [])
    .map((src) => `<img src="${src}" width="300" loading="lazy">`)
    .join('');

  const qtyOptions = Array.from({ length: 9 }, (_, i) => i + 1)
    .map((n) => `<option value="${n}"${n === 1 ? ' selected' : ''}>${n}</option>`)
    .join('');

  const desc = `${buildTruncatedDescription(product.description)}`;
  const suboptions = `<span class="appstle_stand_alone_selector" data-product-data="${ product }" style="display:none;"></span>`;

  /*const subscription = `
    <div class="appstle_sub_widget WIDGET_TYPE_7" id="appstle_subscription_widget0" data-morph-skip="">
    <div class="appstle_widget_title">Purchase Options</div>
    <div class="appstle_subscription_wrapper">
        <div class="appstle_subscription_wrapper_option appstle_selected_background appstle-active-option">
        <div class="appstle_one_time_details_wrapper">
            <input type="radio" checked="" id="appstle_selling_plan_label_10" name="selling_plan" value="">
            <label for="appstle_selling_plan_label_10" class="appstle_radio_label">
                <span class="appstle_circle"><span class="appstle_dot"></span></span>
                <span class="appstle_one_time_text">One-Time Purchase</span>
            </label>
            <div class="appstle_one_time_price_wrapper">
                <span class="appstle_subscription_amount transcy-money">${formatMoney(currentVariant.compare-at-price)}</span>
                <span class="appstle_subscription_amount-appstle-sr-only transcy-money sr-only">Sale price $94.95</span>
                <span class="appstle_subscription_amount_compare_at_price transcy-money"></span>
                <span class="appstle_subscription_amount_compare_at_price-appstle-sr-only transcy-money sr-only"></span>
                <div class="appstle_one_time_unit_price"></div>
            </div>
        </div>
        <span class="appstle_bundle_discount_amount one_time_discount"></span>
        <div class="appstle_one_time_description_text"></div>
            
    </div>
    <div class="appstle_subscription_wrapper_option appstle_include_dropdown payAsYouGoPlansDropdownWrapper">
        <div class="appstle_subscription_radio_wrapper">
            <input type="radio" id="appstle_selling_plan_label_20" name="selling_plan" value="5713952830">
            <label for="appstle_selling_plan_label_20" class="appstle_radio_label">
                <span class="appstle_circle"><span class="appstle_dot"></span></span>
                <span class="appstle-text-and-badge-wrapper">
                <span class="appstle_subscribe_save_text">Subscribe &amp; Save</span>
                <span class="appstle-save-badge">SAVE 30%</span>
                </span>
            </label>
            <div class="appstle_subscription_amount_wrapper">
                <span class="appstle_subscription_amount transcy-money">$66.47</span>
                <span class="appstle_subscription_amount-appstle-sr-only transcy-money sr-only">Sale price $66.47</span>
                <span class="appstle_subscription_compare_amount transcy-money">$94.95</span>
                <span class="appstle_subscription_compare_amount-appstle-sr-only transcy-money sr-only">Original price $94.95</span>
            </div>
            </div>
            <span class="appstle_bundle_discount_amount subscription_discount"></span>
            <div class="appstle_subscription_description_text"></div>

            <div class="appstle_subscribe_option appstle_hide_subsOption">
                <div class="appstle_subscribe_option_grid">
                    <label for="appstle_selling_plan0" class="appstle_select_label">DELIVERY FREQUENCY</label>
                    <div class="appstle_custom_select">
                        <select id="appstle_selling_plan0" class="appstle_select">
                            <option value="5713952830">Delivery Every 2 Weeks (Dedicated Use)</option><option value="5713985598">Delivery Every 4 Weeks (Recommended)</option><option value="5714018366">Delivery Every 6 Weeks (Regular Use)</option><option value="5714051134">Delivery Every 8 Weeks (A Few Times a Week)</option>
                        </select>
                    </div>
                </div>
            <div>
        </div>
    </div>
    </div>
    </div>
    <div class="appstle-tootltip-parent">
        <div data-appstle-icon="" class="appstle_tooltip_wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 735.67 735.7" fill="#000000" class="tooltip_subscription_svg">
            <path d="M835.31,378.69c0,29.32-.3,58.65.12,88,.23,15.77-3.66,19.57-17,24.46-28.91,10.58-58,20.77-86.91,31.24q-41.58,15-83.06,30.33a21.81,21.81,0,0,1-15.8.07q-54.92-20.09-109.89-40c-21.7-7.88-43.42-15.7-65.11-23.61-7.94-2.9-12-8.88-12-17.42,0-60.48.18-121-.13-181.44-.08-15.77,3.67-19.57,17-24.46,28.91-10.58,58-20.77,86.91-31.24q41.58-15,83.06-30.33a21.81,21.81,0,0,1,15.8-.07q54.92,20.08,109.89,39.95c21.7,7.88,43.42,15.7,65.11,23.61,7.94,2.89,12,8.88,12,17.42ZM477.58,306.43V462.31l146.86,53.27V359.7Zm179.08,53.24V515.55l146.79-53.27V306.41ZM508.28,283.41l44.64,16.31q39.44,14.4,78.88,28.83c5.5,2,10.58,2.58,16.48.31,23.21-9,46.62-17.4,70-25.89,18-6.53,36.06-12.85,54.43-19.38l-44.64-16.31q-39.44-14.4-78.87-28.83c-5.51-2-10.59-2.58-16.49-.31-23.21,9-46.62,17.4-70,25.89C544.72,270.56,526.65,276.88,508.28,283.41Z" transform="translate(-272.69 -9.55)"></path>
            <path d="M929.83,606.69c18,0,35.46,0,52.95,0,10.33,0,17.33,7.19,17.34,17.68s-6.94,17.91-17.1,17.92q-50.74,0-101.49,0a16.44,16.44,0,0,1-16.83-16.57q0-51,0-102c0-10,7.51-16.88,18.15-16.86C893,506.9,900.28,514,900.3,524c0,19.16,0,38.32.94,58.1,2.74-3.72,5.52-7.41,8.21-11.17a333.52,333.52,0,0,0,46.64-93.12c2.92-9.14,5.9-18.32,7.8-27.7,2.48-12.29,4.13-24.76,5.75-37.2,1.31-10,2.51-20.05,2.87-30.12a184.88,184.88,0,0,0-1-27.84c-1.77-15.09-3.46-30.3-6.93-45a528.57,528.57,0,0,0-15.47-51.72c-4.06-11.7-8.82-23.42-15.11-34-10.9-18.41-22.31-36.66-35.18-53.71a280.62,280.62,0,0,0-57.56-56.47c-30.93-22.82-64.47-40.82-101.41-52-11.23-3.4-22.52-7-34.05-8.87-18.07-3-36.37-4.63-54.58-6.76s-35.94.86-53.87,2.82c-34.64,3.8-67.22,14.36-98.61,28.94-11.11,5.16-21.53,11.8-32.73,16.7-9.64,4.22-19.19,1.58-24.43-7.93-4.55-8.24-1.25-18.81,6.77-24C472,47.39,498,36.91,524.53,27.66c20.2-7.06,41-11.36,62.28-14.2,21.62-2.89,43.3-4.76,65-3.53,19.43,1.1,38.74,4.26,58.11,6.5,25.29,2.93,48.76,12.16,72.15,21.4,15.56,6.15,30.9,12.9,44.8,22.54s28.54,17.78,41.64,28.15a369.67,369.67,0,0,1,80,87.16,383,383,0,0,1,41.46,84.73,303.71,303.71,0,0,1,14.57,63.22c2.54,20.79,4.48,41.59,3.67,62.5-.56,14.53-1.94,29.08-3.9,43.49s-4.2,29.17-7.95,43.33a349.09,349.09,0,0,1-23.48,63.25c-11.83,24.33-25.66,47.31-42.46,68.49C930.1,605,930.11,605.61,929.83,606.69Z" transform="translate(-272.69 -9.55)"></path>
            <path d="M348.34,152.31c-18,0-35,0-52,0-10.58,0-17.46-7.18-17.45-18.07,0-10.41,7.08-17.53,17.5-17.53q50.49,0,101,0c9.78,0,16.92,7.17,16.92,17q0,50.51,0,101c0,10.32-7.25,17.52-17.58,17.59-10.66.07-18-7.1-18-17.66q0-27.24,0-54.5v-4.77l-1.47-.59c-5,7.52-10.66,14.71-15,22.62-10.66,19.69-21.75,39.26-30.65,59.74-6.42,14.77-10.15,30.8-14.09,46.51-4.53,18.13-8.35,36.45-8.3,55.35,0,9.29-1.34,18.63-.75,27.86.91,14.17,2.45,28.33,4.66,42.35A347,347,0,0,0,321.47,469c8.13,29,20.55,56.17,36.27,82,10,16.47,21.65,31.5,34,46.06,12.85,15.12,27.67,28.2,43,40.85,19.29,15.92,40.85,28,63,39.07,23.08,11.58,47.58,19.29,72.79,24.62,12.92,2.73,25.94,5.7,39.05,6.69,15.83,1.2,31.82.68,47.72.4,9.09-.15,18.35-.38,27.21-2.18,18.6-3.78,37.12-8.15,55.43-13.2a242,242,0,0,0,32.56-12c12.29-5.37,24.14-11.77,36.22-17.65,9.46-4.6,19.84-1.52,24.61,7.21,4.66,8.52,1.49,20.24-7.36,25.23-23.17,13-46.71,25.41-72.65,32.1-20.48,5.29-41.12,9.95-61.73,14.75a53.29,53.29,0,0,1-10.84,1.24c-21.29.44-42.6,1.33-63.87.92-28.13-.55-55.51-6.64-82.47-14.18-30.18-8.44-58.19-22.11-85.19-37.92-22.54-13.2-42.44-29.72-61.62-47.33a354.47,354.47,0,0,1-54.93-64.44c-17-25.44-31.62-52.52-40.58-81.87C285,476.05,278.54,452.14,275.39,428c-3.18-24.42-2.88-49.44-2.41-74.16.63-32.66,8.07-64.38,18.49-95.16a337,337,0,0,1,22-50.51c9.59-18,21.31-34.77,32.12-52.07C346.23,155,347.06,154,348.34,152.31Z" transform="translate(-272.69 -9.55)"></path>
            </svg>
            <span class="appstle_tooltip_title">Subscription detail</span>
        </div>
        <div class="appstle_tooltip">
            <div class="appstle_tooltip_content"><strong>Have complete control of your subscriptions</strong><br><br>Skip, reschedule, edit, or cancel deliveries anytime, based on your needs.</div>
                <span></span>
            </div>
        </div>
    </div>`;*/

  
  const html = `
  <product-form id="productSlideoutProduct" class="js-product product-info" data-product-id="${product.id}">
    <div class="atc-image-gallery">${imagesHtml}</div>
    <div class="detail">
        <div class="product-form" id="ProductInfo-${product.id}" data-ajax-add-to-cart="true">
            <div class="title-row">
                <h1 class="product-title">${product.title}</h1>
                </div>
                
          <div class="price-container">
            <div class="product-info__price product-price product-price--large" role="status">
              ${formatMoney(currentVariant.price)}
            </div>
          </div>

          ${desc}

          <div class="input-row">
            ${buildVariantPicker(product)}
          </div>

          <form class="form js-product-form" data-product-id="${product.id}">
            <div class="input-row">
              <input type="hidden" name="id" value="${currentVariant.id}" required>
              <div class="quantity-submit-row input-row">
                <div class="qty-wrapper">
                  <label class="label" for="quantity">Quantity</label>
                  <quantity-wrapper class="buttoned-input">
                    <select aria-label="Quantity" id="quantity" name="quantity">${qtyOptions}</select>
                  </quantity-wrapper>
                </div>

                <div class="quantity-submit-row__submit">
                  <div class="js-form-error lightly-spaced-row" role="alert" hidden></div>
                  <button class="btn btn--large add-to-cart" type="submit"${!currentVariant.available ? ' disabled' : ''}>
                    ${currentVariant.available ? 'Add to cart' : 'Sold out'}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </product-form>
  `;

  const container = document.querySelector('.atc-drawer__content');
  container.innerHTML = html;

  // Re-attach behavior after re-render
  attachDescriptionToggle(container);
  attachDrawerEvents(container, product);
}

function attachDescriptionToggle(container) {
  const wrapper = container.querySelector('.description-wrapper');
  if (!wrapper) return;
 
  console.log('got here');
  const content = wrapper.querySelector('.description-content');
  const toggle = wrapper.querySelector('.description-toggle');
 
  toggle.addEventListener('click', () => {
    const isExpanded = wrapper.dataset.expanded === 'true';
 
    wrapper.dataset.expanded = String(!isExpanded);
    content.classList.toggle('description-content--clamped', isExpanded);
    toggle.setAttribute('aria-expanded', String(!isExpanded));
    toggle.textContent = isExpanded ? 'Read more' : 'Read less';
  });
}

function attachDrawerEvents(container, product) {
  const checkboxes = container.querySelectorAll('.variant-option-checkbox');
  const groupIndexes = [...new Set(Array.from(checkboxes).map((cb) => cb.dataset.optionIndex))];

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      const groupIndex = checkbox.dataset.optionIndex;

      // Enforce single-selection within this option's group. Clicking the
      // label toggles the checkbox natively and fires this same 'change'
      // event, so unchecking the currently-selected box just re-checks it —
      // a variant option group should never end up with zero selections.
      if (!checkbox.checked) {
        checkbox.checked = true;
        return;
      }

      container
        .querySelectorAll(`.variant-option-checkbox[data-option-index="${groupIndex}"]`)
        .forEach((cb) => {
          if (cb !== checkbox) cb.checked = false;
        });

      // Recompute the selected value for every option group, in order
      const selectedOptions = groupIndexes.map((idx) => {
        const checked = container.querySelector(
          `.variant-option-checkbox[data-option-index="${idx}"]:checked`
        );
        return checked ? checked.value : null;
      });

      const variant = findMatchingVariant(product, selectedOptions);
      if (!variant) return;

      container.querySelector('input[name="id"]').value = variant.id;
      container.querySelector('.product-price--large').textContent = formatMoney(variant.price);

      const btn = container.querySelector('.add-to-cart');
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? 'Add to cart' : 'Sold out';
    });
  });

  // Add to cart via the standard Cart AJAX API
  const form = container.querySelector('.js-product-form');
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const id = form.querySelector('input[name="id"]').value;
    const quantity = form.querySelector('select[name="quantity"]').value;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity }] }),
      });
      if (!res.ok) throw new Error('Add to cart failed');
      // e.g. trigger your cart drawer refresh / open here
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      closeATCDrawer();
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
    } catch (err) {
      const errorEl = container.querySelector('.js-form-error');
      errorEl.hidden = false;
      errorEl.textContent = 'Something went wrong adding this to your cart.';
    }
  });
}

// This is the function you call from anywhere: loadProduct('some-handle')
async function loadProduct(handle) {
  const res = await fetch(`/products/${handle}.js`);
  if (!res.ok) {
    console.error(`Product not found: ${handle}`);
    return;
  }
  const product = await res.json();

  renderProductDrawer(product);
}
  } catch(e) { console.error(e); }
})();

})();
